import { render, staticRenderFns } from "./AddActivityPage.vue?vue&type=template&id=94d5f6f4&"
import script from "./AddActivityPage.vue?vue&type=script&lang=js&"
export * from "./AddActivityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports